/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomerImportDtoFromJSON, CustomerImportDtoToJSON, } from './';
export function CustomerImportRequestFromJSON(json) {
    return CustomerImportRequestFromJSONTyped(json, false);
}
export function CustomerImportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'importItems': !exists(json, 'importItems') ? undefined : (json['importItems'] === null ? null : json['importItems'].map(CustomerImportDtoFromJSON)),
    };
}
export function CustomerImportRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'importItems': value.importItems === undefined ? undefined : (value.importItems === null ? null : value.importItems.map(CustomerImportDtoToJSON)),
    };
}
